import styles from "./Alert.module.css";
import { STATUSES } from "../container/FormContainer";

export const Alert = ({ type }) => {
    let className = styles.alert;
    let message;

    if (type === STATUSES.SUCCESS) {
        className += ` ${styles.success}`
        message = 'Подписка успешно оформлена'
    }

    if (type === STATUSES.ERROR) {
        className += ` ${styles.error}`
        message = 'Что-то пошло не так. Попробуйте еще раз'
    }

    return <div className={className}>{message}</div>
}